/* eslint-disable @angular-eslint/prefer-inject */
import { InventoryAdjustmentDataService } from '../infrastructure/inventory-adjustments/inventory-adjustment.data.service';
import {
    InventoryAdjustmentCreate,
    InventoryAdjustmentDto,
    InventoryAdjustmentRead,
    InventoryAdjustmentSearchParams,
} from '../entities/inventory-adjustment.dto';
import { InventoryAdjustmentStore } from '../infrastructure/inventory-adjustments/inventory-adjustment.store';
import { inject, Injectable } from '@angular/core';
import { AbstractManageEntityFacade } from '@pf/shared-services';
import { InventoryAdjustmentMapper } from '../infrastructure/inventory-adjustments/inventory-adjustment.mapper';
import { BuildChangeTrackingFacadeFactory } from '@pf/shared/util-platform';
import { WarehouseFacade } from './warehouse.facade';
import { IQueryParams, SafeAny } from '@pf/shared-common';
import { map, Observable } from 'rxjs';
import { ResourceAuth } from '@control-tower/platform-wms';

@Injectable()
export class InventoryAdjustmentFacade extends AbstractManageEntityFacade<
    InventoryAdjustmentDto,
    InventoryAdjustmentRead,
    InventoryAdjustmentCreate,
    InventoryAdjustmentSearchParams
> {
    private readonly warehouseFacade = inject(WarehouseFacade);
    nameField: keyof InventoryAdjustmentDto = 'adjustmentReason';

    constructor(
        dataService: InventoryAdjustmentDataService,
        store: InventoryAdjustmentStore,
        mapper: InventoryAdjustmentMapper
    ) {
        super(dataService, null, store, mapper);
    }

    override getDefaultSearchParams$(
        params: IQueryParams<InventoryAdjustmentDto>
    ): Observable<IQueryParams<InventoryAdjustmentDto>> {
        return this.warehouseFacade.addDefaultWarehouseParam(params);
    }

    override applyResourceAuth(body: InventoryAdjustmentCreate): void {
        const locationId = this.warehouseFacade.active?.location?.id;
        body.resourceAuth = {
            locations: locationId ? [locationId] : [],
        } as ResourceAuth;
    }

    changeTrackingFactory = BuildChangeTrackingFacadeFactory(
        this.dataService,
        this.nameField
    );

    textSearchFilter(
        searchText: string
    ): Partial<Record<keyof InventoryAdjustmentDto, string>> {
        return { adjustmentReason: searchText };
    }

    getBySlotId(slotId: string, numOfRecords = 50) {
        return this.search$({
            pageIndex: 1,
            pageSize: numOfRecords,
            sortOrder: 'descend',
            sortField: 'createdDate',
            filters: {
                slotId: slotId,
            } as SafeAny,
        }).pipe(map(res => res.data));
    }

    getByItemId(itemId: string, numOfRecords = 50) {
        return this.search$({
            pageIndex: 1,
            pageSize: numOfRecords,
            sortOrder: 'descend',
            sortField: 'createdDate',
            filters: {
                itemId: itemId,
            } as SafeAny,
        }).pipe(map(res => res.data));
    }
}
